export const STATION_TYPE = [
  {value: 'in', text: 'In'},
  {value: 'out', text: 'Out'},
  {value: 'in-out', text: 'In-Out'}
];
